<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-emissions/>
		<VMain>
			<breadcrumbs />
			<v-container>
				<v-row class="contentRow" align="center">
					<v-col>
						<h1>Suppliers' CO₂ Emission Results</h1>
					</v-col>
				</v-row>
				<v-row class="contentRow" align="center">
					<v-col>
						<v-card>
							<v-data-table :items="tabledata" :headers="headers" item-value="name">
								<template v-slot:item="{ item }">
									<tr>
										<td>{{ item.name }}</td>
										<td style="padding-left: 50px;">{{ item.country }}</td>

										<template v-if="item.totalEmission === '-'">
											<td style="padding-left: 50px;">-</td>
										</template>
										<template v-else>
											<td>
												<v-chip class="ma-1" color="#00838F" style="cursor: pointer;" text-color="#ffff">
													<div class="font-weight-bold text-uppercase"
														style=" font-size: 1.1rem; " @click="openDialog(item)">
														Total: <span class="font-weight-regular" style="">{{
															item.totalEmission.toLocaleString() }}</span>
													</div>
													&nbsp;Kg
												</v-chip>
											</td>
										</template>
										<template v-if="!hasEmissionData(item)">
											<td>
												<v-chip class="ma-1">Scope 1: {{
													formattedScope(item.scope.scope1) }}</v-chip><br>
												<v-chip class="ma-1">Scope 2: {{
													formattedScope(item.scope.scope2) }}</v-chip><br>
												<v-chip class="ma-1">Scope 3: {{
													formattedScope(item.scope.scope3) }}</v-chip>
											</td>
										</template>
										<template v-else>
											<td>
												<v-chip class="ma-1" color="#ffcdd2" text-color="#b71c1c">Scope 1: {{
													formattedScope(item.scope.scope1) }}&nbsp;Kg</v-chip><br>
												<v-chip class="ma-1" color="#ffe0b2" text-color="#f57c00">Scope 2: {{
													formattedScope(item.scope.scope2) }}&nbsp;Kg</v-chip><br>
												<v-chip class="ma-1" color="#c5cae9" text-color="#3949ab">Scope 3: {{
													formattedScope(item.scope.scope3) }}&nbsp;Kg</v-chip>
											</td>
										</template>
										<td style="padding-left: 50px;">{{ formatEmissionPerEur(item.emissionpereur) }}
										</td>
										<td style="padding-left: 30px;">{{ item.filledoutdate }}</td>
									</tr>
								</template>
							</v-data-table>

						</v-card>

						<v-dialog v-model="dialog" max-width="550px" max-height="90vh" @click:outside="dialog = false"
							@close="resetCheckboxes">
							<v-card style="height: auto; max-height: 90vh; overflow: hidden;">
								<v-card-title class="text-center font-weight-bold text-h4">
									Total Emissions
								</v-card-title>
								<v-card-text style="display: flex; flex-direction: column; align-items: center;">
									<v-row no-gutters style="width: 100%;">
										<v-col align="center" cols="12">
											<emission-pie-charts :chartData="dialogItem" />
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-dialog>
					</v-col>
				</v-row>
			</v-container>
			<orixe-footer />
		</VMain>
	</v-app>
</template>

<script>
import EmissionsApi from "../../api/emissions/emissions"

import Breadcrumbs from "../../components/Breadcrumbs.vue"
//import NavBarConnections from "../../components/NavBarConnections.vue"
import LoadingState from "../../consts/LoadingState"
import EmissionPieCharts from "../../components/EmissionPieCharts2.vue"
export default {
	components: {  Breadcrumbs,EmissionPieCharts },
	data() {
		return {
			connections: [],
			avgScore: [],
			emissionEnergy: null,
			emissionBusinessTrips: null,
			emissionIngoingShipping: null,
			emissionOutgoingShipping: null,
			emissionCompanyOrganization: null,
			totalEmission: null,
			tabledata: [],
			headers: [
				{ text: "Supplier", value: "name" , sortable: false},
				{ text: "Country of Operation", value: "country" , sortable: false},
				{ text: "Total CO₂ Emission", value: "totalEmission" , sortable: false},
				{ text: "Scope CO₂ Emission", value: "scope" , sortable: false},
				{ text: "CO₂ per EUR", value: "emissionpereur" , sortable: false },
				{ text: "Filled out", value: "filledoutdate" , sortable: false},
			],
			dialog: false,
			dialogItem: null,
			currentYear: null,
		}
	},
	mounted() {
		this.loadItems1()
	},
	methods: {
		hasEmissionData(item) {
			return item.totalEmission !== "-"
		},
		formatEmissionPerEur(value) {
			if (value === "-" || value == null) return "-"
			const num = Number(value)
			if (!Number.isFinite(num)) return "-"
			if (Math.abs(num) >= 100) return Math.round(num).toLocaleString()
			if (Math.abs(num) >= 1) {
				return num.toLocaleString(undefined, { maximumFractionDigits: 2 })
			}
			return num.toLocaleString(undefined, { maximumFractionDigits: 4 })
		},
		sumScopeArray(scopeArr) {
			if (!Array.isArray(scopeArr)) return null
			return scopeArr.reduce((sum, value) => sum + (Number(value) || 0), 0)
		},
		sumScope3(scope3) {
			if (!Array.isArray(scope3)) return null
			return [3, 4, 5, 6, 8].reduce(
				(sum, index) => sum + (Number(scope3[index]) || 0),
				0
			)
		},
		formattedScope(value) {
			if (value === null || value === undefined || value === "-") return "-"
			const num = Number(value)
			return Number.isFinite(num) ? num.toFixed(2) : "-"
		},
		buildPieChartData(categories, totalEmission, year) {
			const values = [
				categories.emissionEnergy,
				categories.emissionBusinessTrips,
				categories.emissionIngoingShipping,
				categories.emissionOutgoingShipping,
				categories.emissionCompanyOrganization,
				categories.emissionPackaging,
			].map((value) => Number(value) || 0)

			return {
				labels: [
					"Energy Consumption",
					"Business Trips",
					"Shipping Incoming",
					"Shipping Outgoing",
					"Facility Organization",
					"Packaging",
				],
				backgroundColor: [
					"#e9891b",
					"#cd1c42",
					"#1e9a74",
					"#388e3c",
					"#6772bc",
					"#8e24aa",
				],
				datasets: [
					{
						labels: [year],
						data: [
							values.map((value) =>
								totalEmission > 0 ? Math.round((value / totalEmission) * 100) : 0
							),
						],
						total: [totalEmission],
					},
				],
			}
		},
		openDialog(item) {
			this.dialogItem = item.pieChartData
			this.dialog = true
		},
		resetCheckboxes() {
			this.dialogItem = null
		},
		loadItems1() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			EmissionsApi.getsuppliersemission()
				.then((data) => {
					this.tabledata = []
					for (let entry of data) {
						let emissionEnergy = "-"
						let emissionBusinessTrips = "-"
						let emissionIngoingShipping = "-"
						let emissionOutgoingShipping = "-"
						let emissionCompanyOrganization = "-"
						let emissionPackaging = "-"
						let totalEmission = "-"
						let filledoutdate = "-"
						let scope1 = "-"
						let scope2 = "-"
						let scope3 = "-"
						let emissionpereur = "-"
						let pieChartData = null
						let yearLabel = null

						if (entry.emissions?.results) {
							const e = entry.emissions.results
							const scope = entry.emissions.scopecalculateEmission
							const hasStoredPackaging = e.emissionPackaging != null

							emissionPackaging = hasStoredPackaging
								? Math.round(Number(e.emissionPackaging) || 0)
								: Math.round(Number(scope?.scope3?.[6]) || 0)
							const storedOrganization = Math.round(Number(e.emissionCompanyOrganization) || 0)
							emissionCompanyOrganization = hasStoredPackaging
								? storedOrganization
								: Math.max(0, storedOrganization - emissionPackaging)

							emissionEnergy = Math.round(Number(e.emissionEnergy) || 0)
							emissionBusinessTrips = Math.round(Number(e.emissionBusinessTrips) || 0)
							emissionIngoingShipping = Math.round(Number(e.emissionIngoingShipping) || 0)
							emissionOutgoingShipping = Math.round(Number(e.emissionOutgoingShipping) || 0)

							totalEmission = Math.round(
								emissionEnergy +
								emissionBusinessTrips +
								emissionIngoingShipping +
								emissionOutgoingShipping +
								emissionCompanyOrganization +
								emissionPackaging
							)

							if (entry.emissions.timestamp) {
								const date = new Date(Number(entry.emissions.timestamp))
								const month = date.toLocaleString("default", { month: "short" })
								yearLabel = date.getFullYear()
								filledoutdate = `${month} ${yearLabel}`
								this.currentYear = yearLabel
							}

							const scope1Total = this.sumScopeArray(scope?.scope1)
							const scope2Total = this.sumScopeArray(scope?.scope2)
							const scope3Total = this.sumScope3(scope?.scope3)

							scope1 = scope1Total == null ? "-" : scope1Total
							scope2 = scope2Total == null ? "-" : scope2Total
							scope3 = scope3Total == null ? "-" : scope3Total

							const revenue = Number(entry.emissions.revenue)
							if (Number.isFinite(revenue) && revenue > 0) {
								emissionpereur = totalEmission / revenue
							}

							pieChartData = this.buildPieChartData(
								{
									emissionEnergy,
									emissionBusinessTrips,
									emissionIngoingShipping,
									emissionOutgoingShipping,
									emissionCompanyOrganization,
									emissionPackaging,
								},
								totalEmission,
								yearLabel || this.currentYear
							)
						}

						this.tabledata.push({
							name: entry.name,
							emissionEnergy,
							emissionBusinessTrips,
							emissionIngoingShipping,
							emissionOutgoingShipping,
							emissionShipping: {
								emissionOutgoingShipping,
								emissionIngoingShipping,
							},
							emissionCompanyOrganization,
							emissionPackaging,
							totalEmission,
							scope: {
								scope1,
								scope2,
								scope3,
							},
							filledoutdate,
							emissionpereur,
							country: entry.COO || "-",
							pieChartData,
						})
					}
					this.tabledata.sort((a, b) => {
						// If a has a valid number and b is "-", a comes first.
						if (a.totalEmission !== "-" && b.totalEmission === "-") return -1
						// If a is "-" and b is a valid number, a comes later.
						if (a.totalEmission === "-" && b.totalEmission !== "-") return 1
						// If both are either valid or "-", maintain their order (or add further sorting if needed).
						return 0
					})
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	},
}
</script>
